var _defs, _polygon, _text, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _rect, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 567.18 411.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{font-size:5.45px;font-family:ProximaNova-Bold, Proxima Nova;font-weight:700;}.cls-16,.cls-19,.cls-2{fill:#231f20;}.cls-3{letter-spacing:-0.01em;}.cls-4{font-family:ProximaNova-Regular, Proxima Nova;font-weight:400;}.cls-5{letter-spacing:-0.02em;}.cls-6{letter-spacing:0em;}.cls-7{letter-spacing:-0.03em;}.cls-8{letter-spacing:-0.02em;}.cls-9{letter-spacing:-0.01em;}.cls-10{letter-spacing:-0.01em;}.cls-11{letter-spacing:-0.05em;}.cls-12{letter-spacing:-0.04em;}.cls-13{letter-spacing:-0.01em;}.cls-14{fill:#812990;}.cls-15{fill:#6b7b84;}.cls-17,.cls-18{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-17{stroke:#ffcb05;}.cls-18{stroke:#6b7b84;}.cls-19{font-size:8px;font-family:ProximaNova-Light, Proxima Nova;font-weight:300;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 463.7,
    y1: 349.69,
    x2: 566.71,
    y2: 349.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#812990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "566.71 392.61 515.2 306.77 463.69 392.61 566.71 392.61"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(188.93 328.03)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3"
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.39,
    y: 0
  }, "angaroo Education Foundation Education &amp; Visa Services"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.27
  }, "Suite 1001, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 26.54,
    y: 7.27
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 29.11,
    y: 7.27
  }, "evel 1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 42.41,
    y: 7.27
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.58,
    y: 7.27
  }, ", 307 Pitt "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 67.88,
    y: 7.27
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.98,
    y: 7.27
  }, "treet"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 0,
    y: 14.54
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 3.16,
    y: 14.54
  }, "ydney NSW 200"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 42.28,
    y: 14.54
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.45,
    y: 14.54
  }, ", "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 48.12,
    y: 14.54
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 51.64,
    y: 14.54
  }, "ustralia"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 0,
    y: 21.81
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.83,
    y: 21.81
  }, ": +61-2-80605365"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 29.07
  }, "ww"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 8,
    y: 29.07
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.76,
    y: 29.07
  }, ".kangarooedu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 44.97,
    y: 29.07
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 46.19,
    y: 29.07
  }, "com")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M70,360.66l-1,.14a3.42,3.42,0,0,1-.48.11c-.38,0-.57-.47-1.09-.58-.13,0,0,0-.2-.06s.07,0-.24-.12c0,.34-.08.24-.08.51a2,2,0,0,0,.22.89c.09.19.14.12.13.4a1.67,1.67,0,0,0,.15,1.11,3,3,0,0,1,.38.79c.51,0,.44,0,.5.15.49,0,.17-.11.44-.15,0,0,.49.12.37-.5.36.09.19.29.42.26s.1-.18.13-.4-.09-.06.25-.22l-.08-.44c0-.51.12,0,.29.07l.22-1.53c0-.12.16-.07-.14-.5C69.89,360.63,70.08,360.64,70,360.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M70.14,359.36c0,.2.12.12-.14.14l.29.65c.13-.07.09,0,.29-.07,0-.44,0-.28-.15-.51S70.34,359.4,70.14,359.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M66.5,358.77c-.07.3,0,0-.09.24s-.13.65.31.41C66.72,358.91,66.77,359,66.5,358.77Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M60.9,353.62a2.56,2.56,0,0,0-.89.14c-.54.14-.3.26-.13.51a3.18,3.18,0,0,0,1.26-.18c.24,0,.26,0,.12-.26H60.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M75.63,350.05c0-.08,0-.16-.06-.25l-.83-.3c-.6-.22-1.19-.44-1.76-.67s-1.19-.49-1.86-.82-1.41-.71-2.14-1.17a4.82,4.82,0,0,1-1.77-2,5.74,5.74,0,0,1-.4-1h-.14a4,4,0,0,0-.8.11l-.75.19a9.87,9.87,0,0,1-2,.39h-.27c-.25,0-.51,0-.77,0a4.91,4.91,0,0,1-.57,0,9.11,9.11,0,0,1-1.22-.22l-.43-.09-.33.39a1.42,1.42,0,0,1,.22.2,1.48,1.48,0,0,1,.31,1.43,2.19,2.19,0,0,1-1.9,1.4c-.24,0-.47,0-.7,0h-.11a2.28,2.28,0,0,1-1.87-1.22,1.66,1.66,0,0,1,.13-1.83l0-.05q.14-.23.3-.45a4.28,4.28,0,0,0,.34-.54l.19-.38a2.5,2.5,0,0,1-2.1-1.58A5.38,5.38,0,0,1,54,340l-.21.05-.34.09a2.23,2.23,0,0,1-.29.31,1.84,1.84,0,0,1-1.29.61,1.81,1.81,0,0,1-.51-.08h-.08a1.74,1.74,0,0,1-1-.3,1.3,1.3,0,0,1-.54-.38,1.27,1.27,0,0,1-.25-1.08,4.62,4.62,0,0,1,.83-1.81l.11-.14a1.67,1.67,0,0,1,.5-1,8.76,8.76,0,0,1,.66-.59l.18-.15a4.1,4.1,0,0,1,.36-.29,2.19,2.19,0,0,1,.35-1,4,4,0,0,1,1.2-1.17c.25-.17.5-.3.74-.44l.37-.2.34-.21.19-.12A1.08,1.08,0,0,1,56,332a1.1,1.1,0,0,1,.47.1,1.15,1.15,0,0,1,.63,1.31l-.37,1.28a2.87,2.87,0,0,1-.54,1,9.35,9.35,0,0,1,.79.54,5.86,5.86,0,0,1,.62.58H58l.17,0a4.12,4.12,0,0,0,1.15-.52l.16-.1a9.72,9.72,0,0,1,2.27-1.08,15.59,15.59,0,0,1,4-.56h.53c.75,0,1.49,0,2.19.08a13.77,13.77,0,0,1,1.67.22,9.72,9.72,0,0,1,4,1.75.74.74,0,0,0-.4-.56c-.21-.1-.1,0-.25-.13l0,0-.16-.13c-.25-.16-.21,0-.31-.35l-.09.05,0,0c-.16.05-.1-.28-.25-.47s.06.14-.31-.05c-.21-.1,0,0-.12-.08s-.06-.05-.15-.08l-.13,0c-.6-.25-.49-.34-.49-.95-.51-.14-.2-.53-.17-.86.06-.54-.26-.6-.13-1.18-.72,0-.43-.71-.63-1.48l0-.7c0-.15,0,.06.08-.21l-.19-.09c-.69-.41-.55-.73-.75-.86l-.5.16c-.15.11,0,.08-.23.13-.48-.45-.25-1.38-.42-2-.06-.26-.11-.61-.46-.7a1.16,1.16,0,0,1,.22-.43c-.17-.09-.26-.07-.43-.15a2.1,2.1,0,0,0-.22-1.16c-.14-.24,0-.26-.37-.29-.08.34,0,.14-.36.29a2.11,2.11,0,0,1-.27,1.12l0,0-.06.08a1.44,1.44,0,0,0-.3.72h.21c0,.33,0,.14-.16.34s-.09,0,0,.36-.26.41-.23.81.12.18.11.44-.08.21-.07.42c0,.54.23.4,0,.92s-.16,1.07-.49,1.61a7,7,0,0,0-.37.79,1,1,0,0,1-.83.32,3.35,3.35,0,0,1-.74-.36.57.57,0,0,1-.31-.26c-.08-.14,0-.09-.08-.21-.17-.36-.66-.33-1-.46s-.47-.62-1.3-1l-.44-.13-.34-.24-.28-.31-.35-.24-.31-.2c-.28-.16-.24,0-.25-.4.16-.05.34-.35.48-.55s0,0,.08-.12l.07-.16s0,0,0-.05l.15-.36c-.3-.12,0,.05-.29-.07.12-.17.09-.08.15-.29.38-.18.28-.08.5,0,.44-.64.19-.24.28-.61s.3-.38.45-.62l-.27-.17c-.3-.16-.23.12-.23-.41a1.3,1.3,0,0,0-.59.43c-.07-.09-.07.15-.07-.21a1.24,1.24,0,0,1-.37.14c.22-.28.12,0,.23-.29a2,2,0,0,0-1,.36c-.18-.13-.29-.11-.36-.36-.36,0-.1,0-.43.15a1.57,1.57,0,0,0-.59-.3v-.14c-.38,0-.64.25-1-.13,0,0-.16-.26-.19-.31-.27.08-.15.08-.37.22a.55.55,0,0,0-.32-.41c-.12-.07,0,0-.15-.05l-.4,0c-.06,0,.1,0-.22.07v.22c.28.06,0,0,.2.08l.06,0,0,0c.22.09.24,0,.58,0a1.7,1.7,0,0,1,.14.66l-.54.18,0,0-.65.08c-.28,0-.18-.07-.29-.28a.87.87,0,0,0-.19.1l-.19.1c-.21.16.11.07-.24.19a.61.61,0,0,1-.33,0c0,.19,0,.18-.16.41s0,.22-.36.25c0,.52.06.22.15.57l-.23.09c-.37.08-.2.08-.32.45s-.31.1-.46.78c.23.16.28.16.33.3a.63.63,0,0,1,0,.27c-.7-.05-.39,0-.64,0a2.88,2.88,0,0,0-.82-.13c0,.54,0,.17-.15.31l0,0-.11.17c0-.5.11-.15.14-.57-.61-.17-.58-.82-1.21-.93s0-.15-.53-.16c-.13.27-.05.32-.29.5.08-.34,0-.11,0-.21-.27.06-.16.07-.36.21-.05-.33-.09-.28-.37-.14.06.22,0,.15.22.22a.79.79,0,0,0-.15.43l-.43-.36c-.19.37,0,.25-.28.45l-.1,0c-.09.06-.11.09-.21.15.11.4.19.08.08.36-.25,0-.27.11-.44.33,0,0,0,0,0,0l0,.06-.12.11c-.1.09-.23.14-.26.36a.55.55,0,0,0,.18.41c-.16.2-.14.13-.15.44l-.32-.1c-.34-.08-.16.18-.26-.11H45c0,.49-.19.37-.08.59s.27.18.44.42c-.18.08-.06.06-.29,0,0,.39.09.13,0,.51-.22-.16-.11-.11-.36-.58s-.27-.16-.23-.65c-.3.08-.28.23-.43.43l-.35.38a1.24,1.24,0,0,0-.29.57c0,.22.13.33.13.72,0,0,0,0,0,.05l.19-.05c0,.16,0,.08-.1.19l-.07.07c-.1.12,0,.05-.11.11l-.12.1,0,0-.09.06c-.18.15-.14.17-.23.37l0,.09c-.44,1.15-.7,1.15-2,1.64-.24.09,0,.06-.27.08s-.19-.17-.49,0,0,.17-.29.36-.41-.11-1.1.58a.59.59,0,0,1-.45.18c-.37,0-.1-.21-.58.11,0-.39.08-.14-.14-.23-.06.24-.05.2-.24.35-.44.33-.09-.1-.72.59l-.07.08-.23.27-.06.09c-.35.38-1.08.22-1.08,1.39h-.22a5.53,5.53,0,0,1-.07-.8,1.66,1.66,0,0,0-.52,1.3c.24.08.07-.12.2.18a1,1,0,0,1-.06.9,1.14,1.14,0,0,0-.14.39v.52c0,.17.07.12.24.32s0,.27.37.64l0,0,.18.26c.29.37.4.18.4,1.05h-.14a1.17,1.17,0,0,0-.81-1c0,.67.18.22.23.72a.56.56,0,0,0-.29-.14c0,.38.06.13-.15.22.47.7,1.21,1,1.39,1.87.07.41.5.62.65,1s0,.05.12.24l.22.21a1,1,0,0,1,.25.63c.25,1.54,1.18,1.86,1.27,2.77l0,.55c-.06.32,0,.26.11.58s0,.43-.1.68a1.68,1.68,0,0,1-.43-.07c0,.52,0,1,.45,1s.82.75,1.83.58a3.72,3.72,0,0,0,1.11-.14c.29-.17.32-.34.43-.46l0,0,.11-.12.06-.07.22-.13c.17,0,.43,0,.51-.25,0,0,0-.12,0-.14.11-.41.68-.4,1.06-.53l.83-.11h.18c.26,0-.08,0,.19,0l.11,0,0,0c.25.12-.2.06.26.09.07-.16.15-.24.61-.23s.85.22,1.09-.76a.72.72,0,0,1,.13-.37c.19-.21.3-.12.59-.29,1.16-.67.71-.79,2-.81a3.89,3.89,0,0,0,1.39-.43c.85-.34.77-.58,2.09-.58a3.51,3.51,0,0,0,.84-.12c.32-.05,1,.46,1.21.62.42-.11.19-.3.71,0a2.52,2.52,0,0,0,.88.2c.1.23,0,0,0,.36.24-.05.24-.09.44,0-.06.16-.14.11-.18.27l.15.42c.18.16.32,0,.5.22s.12.31.39.64a1.18,1.18,0,0,1,.23.71s0,0,0,0h-.07l-.19.19c.44,0,.33.32.72.41.14,0,0,0,.15,0s0,0,.15.06l0-.29c-.06-.22,0-.29.43-.79.26-.34.77-.34,1-.71a2,2,0,0,1,.32-.55c.18-.19,0,.08.16-.2,0,.05,0,0,0,0l.07.09.12.17c-.22,0-.19,0-.29.14.15.33.16.29,0,.49a1.71,1.71,0,0,0-.37,1.14c0,.43-.09.33-.5.33-.07.27-.12.2-.15.51a1.41,1.41,0,0,0,.51-.15c.31-.07.35.17.52-.21l.29-.87.13.22s0,0,0,.05l0,.1,0,0c.41.82-.27.84-.31,1.32a2.54,2.54,0,0,0,.73-.13s0,0,0,0,0,0,0,0c.45.38.93.88.73,1.55,0,0,0,0,0,0l0,.36a1.17,1.17,0,0,0,.31.46l.3.49c.22.25.56.14.81.43l.21.23c.21-.07.21-.16.43-.09l.17.06.06,0c.19.05.1,0,.28.09s.74.41.8.57c.41,0,1.19-1,1.38-.29.37,0,.38-.25.66-.28l-.05.09c-.1.22,0-.13-.1.27l.35.31.1.11.23.08a.6.6,0,0,1,.13.3.35.35,0,0,0,.21-.51c.86,0,1.1-.86,2-.82.59,0,1,.2,1.48-.14l.15-.21c.11-.25,0-.32,0-.54l.39-1.06a1.39,1.39,0,0,1,.77-.93c.21-.18,0-.06.07-.2v0l.05-.19a1.42,1.42,0,0,1,.39-.69c.43-.36.25-.6.89-1.29l.42-.24.05,0,.15-.11C75.82,351.06,75.73,350.55,75.63,350.05Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M43.59,333.13Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M57,337.79a8.26,8.26,0,0,0-.74-.72,10.24,10.24,0,0,0-1.12-.73,1.88,1.88,0,0,0-.57-.22.8.8,0,0,0-.35,0,2.47,2.47,0,0,1,.6-.69,2.12,2.12,0,0,0,.8-1.07c.13-.43.25-.85.37-1.27l0,0-.56.35c-.35.2-.72.38-1.06.6a3,3,0,0,0-.88.85,1.27,1.27,0,0,0-.17.89c0,.21-.1.21-.1.21a1.57,1.57,0,0,0-.65.39c-.26.22-.53.44-.77.68a.7.7,0,0,0-.2.39,1.22,1.22,0,0,1-.3.66,3.36,3.36,0,0,0-.64,1.38c0,.17,0,.24.23.21a.53.53,0,0,0,.58.22s.07,0,.09,0c.37.19.55.15.9-.18a2.18,2.18,0,0,0,.25-.28c.17-.26.46-.29.72-.36a2,2,0,0,0,.9-.36s.2-.17.29-.05a2.49,2.49,0,0,1,.35.47,1.89,1.89,0,0,1,.17.69,4.62,4.62,0,0,0,.26,1.33A1.43,1.43,0,0,0,57,342a2.71,2.71,0,0,1,1.44,0l.28.12-.54,0c-.09,0-.14,0-.18.12-.25.6-.5,1.2-.79,1.78-.19.37-.47.71-.69,1.07s-.33.46-.17.72a1.27,1.27,0,0,0,1,.71l.74,0a1.16,1.16,0,0,0,.86-.64.39.39,0,0,0-.11-.4c-.07.18-.21.21-.37.23a.62.62,0,0,0-.24.1c0-.16.15-.16.29-.2l0-.32-.08.05a.36.36,0,0,1-.49.17l-.2-.07c-.21-.06-.25,0-.27.17a1,1,0,0,1,0,.16.44.44,0,0,1,0-.57c.27-.34.54-.67.84-1A11.14,11.14,0,0,0,60.05,342a1.65,1.65,0,0,0,.16-.42.84.84,0,0,0-.39-.86,7.84,7.84,0,0,0-1-.61.72.72,0,0,1-.44-.86l.09.28c.08.26.32.34.53.45s.67.32,1,.51a1,1,0,0,1,.32,1.61c-.18.27-.35.56-.52.84-.07.11-.07.17.09.2.58.11,1.16.27,1.75.34a8.56,8.56,0,0,0,1.43,0,14.6,14.6,0,0,0,2.61-.55,3.94,3.94,0,0,1,1.53-.09s.07,0,.11,0l-.09-.82c0-.23,0-.45-.07-.68a5.54,5.54,0,0,0-.54-2.22c-.06-.12-.15-.22-.23-.35a1.28,1.28,0,0,1,.5.45,2.72,2.72,0,0,1,.41,1.1c.13.67.21,1.34.33,2a7.41,7.41,0,0,0,.6,2.1,3.7,3.7,0,0,0,1.37,1.56,22.58,22.58,0,0,0,2,1.12c.58.29,1.18.54,1.78.78s1.49.57,2.24.85l1.09.4a.65.65,0,0,1,.43.41l-.59-.3,0,0c.06.21.14.42.18.63.11.56.21,1.13.31,1.7s.15.88.21,1.32c0,.25,0,.49,0,.74a1.57,1.57,0,0,0,.34,1,2.41,2.41,0,0,0,.24.21,7.91,7.91,0,0,1,1.26,1.56,1.2,1.2,0,0,0,.44.4h.35a.17.17,0,0,0,0-.1.4.4,0,0,1,0-.55,2,2,0,0,0,.16-.4c0-.24-.12-.41-.24-.58l-.14-.18-.29.39,0,0a.68.68,0,0,0,.11-.78,1.3,1.3,0,0,0-.49-.66,1.19,1.19,0,0,1-.57-1c-.08-.51-.13-1-.18-1.53a6.8,6.8,0,0,1-.07-.89c0-.43.1-.86.13-1.29a1,1,0,0,0-.26-.7,5.73,5.73,0,0,0-1.19-.88c-.75-.52-1.5-1-2.22-1.6a10.47,10.47,0,0,1-2.43-2.79,3.18,3.18,0,0,1-.41-1.25,2,2,0,0,1,.13-1,4.47,4.47,0,0,0,.25,1.81c.39-.1.74-.25.81-.68a3,3,0,0,0-.06-.78c0-.23.09-.37.33-.32a1.24,1.24,0,0,1,.75.57c.6.89,1.17,1.8,1.75,2.7.35.55.7,1.1,1.06,1.64.5.72,1,1.44,1.52,2.14a11.65,11.65,0,0,0,.92,1.06c.28.32.59.61.89.9a11.21,11.21,0,0,0,2,1.48,10.85,10.85,0,0,0,2.79,1.22,16.39,16.39,0,0,0,2.08.45,9.2,9.2,0,0,0,1.74.11,12.83,12.83,0,0,0,1.84-.22,10.31,10.31,0,0,0,2.75-.95c.42-.21.82-.48,1.23-.73a.18.18,0,0,0,.07-.08c0-.09,0-.19,0-.28s-.17-.05-.24,0-.43.17-.64.27a12.33,12.33,0,0,1-2.34.84,9.19,9.19,0,0,1-1.63.31,12,12,0,0,1-1.8,0,7.48,7.48,0,0,1-3.09-.88,9.35,9.35,0,0,1-2.08-1.45c-.23-.21-.47-.43-.69-.65a15.89,15.89,0,0,1-1.65-2,32.22,32.22,0,0,1-1.74-2.87l-1.16-2.14a21.33,21.33,0,0,0-1.89-3,13.34,13.34,0,0,0-1.5-1.6,8.62,8.62,0,0,0-4.13-2,11,11,0,0,0-1.53-.21c-.87,0-1.75-.09-2.62-.07a14.36,14.36,0,0,0-3.74.52,9.88,9.88,0,0,0-2.19,1.07,5,5,0,0,1-1.47.65,1.83,1.83,0,0,1-.4.05,6.26,6.26,0,0,0-.87,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M152.5,326.28h-.59v1.66h-.34v-1.66H151v-.34h1.52Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M154.65,325.94v2h-.35v-1.42l-.66,1-.65-1v1.42h-.35v-2H153l.62,1,.63-1Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M99.72,331.14v.64a4.42,4.42,0,0,0-1.14-.61,4.21,4.21,0,0,0-1.48-.24,4.43,4.43,0,0,0-1.72.33,4.16,4.16,0,0,0-1.37.91,4.31,4.31,0,0,0-.9,1.35,4.44,4.44,0,0,0,0,3.31,4.43,4.43,0,0,0,.9,1.35,4.16,4.16,0,0,0,1.37.91,4.43,4.43,0,0,0,1.72.33h.17A4.76,4.76,0,0,0,99,339.1v-2.3h0a2.23,2.23,0,0,1-.79.51,2.7,2.7,0,0,1-.94.17,2.56,2.56,0,0,1-.39,0h0a3.41,3.41,0,0,1-.55-.14,2.15,2.15,0,0,1-.79-.51,2.24,2.24,0,0,1,0-3.27,2.41,2.41,0,0,1,.79-.5,2.5,2.5,0,0,1,.94-.18,2.42,2.42,0,0,1,1.73.68,2.17,2.17,0,0,1,.72,1.64v4.24h2v-8.28Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M91.09,339.42l-4.51-4.35v4.35h-2V327.94h2v4.34L91.09,328H94l-6,5.71,6,5.75Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M107.05,330.93a3.87,3.87,0,0,1,1.51.29,3.47,3.47,0,0,1,1.16.83,3.68,3.68,0,0,1,.75,1.21,4.1,4.1,0,0,1,.26,1.49v4.67h-2v-4.67a1.71,1.71,0,0,0-.6-1.34,1.92,1.92,0,0,0-1.39-.55,2,2,0,0,0-1.41.55,1.79,1.79,0,0,0-.58,1.34v4.67h-2v-8.27h2v.61a4.42,4.42,0,0,1,1-.6A3.3,3.3,0,0,1,107.05,330.93Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M134.66,331.15a3.68,3.68,0,0,1,1.37-.24v1.93a2.46,2.46,0,0,0-1.74.68,2.28,2.28,0,0,0-.71,1.65v4.25h-2v-8.28h2v.62A4.72,4.72,0,0,1,134.66,331.15Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M140.64,330.93a4.57,4.57,0,0,1,1.74.33,4.42,4.42,0,0,1,1.43.91,4.16,4.16,0,0,1,1,1.35,4.09,4.09,0,0,1,0,3.31,4.27,4.27,0,0,1-1,1.35,4.42,4.42,0,0,1-1.43.91,4.78,4.78,0,0,1-3.49,0,4.42,4.42,0,0,1-1.43-.91,4.27,4.27,0,0,1-1-1.35,4.09,4.09,0,0,1,0-3.31,4.16,4.16,0,0,1,1-1.35,4.42,4.42,0,0,1,1.43-.91A4.58,4.58,0,0,1,140.64,330.93Zm0,1.93a2.46,2.46,0,0,0-1.74.68,2.24,2.24,0,0,0,0,3.27,2.15,2.15,0,0,0,.79.51,2.75,2.75,0,0,0,.95.17,2.69,2.69,0,0,0,.93-.17,2.37,2.37,0,0,0,.8-.51,2.24,2.24,0,0,0,0-3.27A2.52,2.52,0,0,0,140.64,332.86Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M150.17,330.93a4.66,4.66,0,0,1,1.75.33,4.49,4.49,0,0,1,1.42.91,4.16,4.16,0,0,1,1,1.35,4.09,4.09,0,0,1,0,3.31,4.27,4.27,0,0,1-1,1.35,4.49,4.49,0,0,1-1.42.91,4.66,4.66,0,0,1-1.75.33,4.58,4.58,0,0,1-1.75-.33,4.53,4.53,0,0,1-1.43-.91,4.43,4.43,0,0,1-1-1.35,4.2,4.2,0,0,1,0-3.31,4.32,4.32,0,0,1,1-1.35,4.53,4.53,0,0,1,1.43-.91A4.58,4.58,0,0,1,150.17,330.93Zm0,1.93a2.42,2.42,0,0,0-1.73.68,2.22,2.22,0,0,0,0,3.27,2,2,0,0,0,.78.51,2.75,2.75,0,0,0,.95.17,2.6,2.6,0,0,0,.93-.17,2.37,2.37,0,0,0,.8-.51,2.24,2.24,0,0,0,0-3.27A2.52,2.52,0,0,0,150.17,332.86Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M128.38,331.14v.64a4.42,4.42,0,0,0-1.14-.61,4.2,4.2,0,0,0-1.47-.24,4.44,4.44,0,0,0-1.73.33,4.11,4.11,0,0,0-1.36.91,4,4,0,0,0-.9,1.35,4.44,4.44,0,0,0,0,3.31,4.17,4.17,0,0,0,2.26,2.26,4.44,4.44,0,0,0,1.73.33h.17a4.76,4.76,0,0,0,1.74-.32v-2.3h0a2.37,2.37,0,0,1-.8.51,2.64,2.64,0,0,1-1.33.14h0a3.05,3.05,0,0,1-.54-.14,2,2,0,0,1-.79-.51,2.22,2.22,0,0,1,0-3.27,2.22,2.22,0,0,1,.79-.5,2.46,2.46,0,0,1,.94-.18,2.43,2.43,0,0,1,1.73.68,2.2,2.2,0,0,1,.71,1.64v4.24h2v-8.28Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M118.51,331.14h0v.63a4.42,4.42,0,0,0-1.14-.61,3.34,3.34,0,0,0-.74-.19,4.79,4.79,0,0,0-.87-.07,4.25,4.25,0,0,0-1.69.33,3.89,3.89,0,0,0-1.33.91,4.23,4.23,0,0,0-.85,1.36,4.34,4.34,0,0,0-.31,1.66h0a4.37,4.37,0,0,0,.32,1.65,4.43,4.43,0,0,0,.9,1.35,4.16,4.16,0,0,0,1.37.91,4.43,4.43,0,0,0,1.72.33h.3a4.76,4.76,0,0,0,1.61-.32v-2.3h0a2.23,2.23,0,0,1-.79.51,2.7,2.7,0,0,1-.94.17,2.56,2.56,0,0,1-.39,0h0a3.41,3.41,0,0,1-.55-.14,2.15,2.15,0,0,1-.79-.51,2.24,2.24,0,0,1-.54-2.49l0-.07a2.17,2.17,0,0,1,.51-.71,2.41,2.41,0,0,1,.79-.5,2.5,2.5,0,0,1,.94-.18,2.42,2.42,0,0,1,1.73.68,2.2,2.2,0,0,1,.52.71l0,.07a2.2,2.2,0,0,1,.17.86v3.23a2.14,2.14,0,0,1-.72,1.62,2.32,2.32,0,0,1-1.73.7,2.39,2.39,0,0,1-1.22-.32l-1.48,1.38a4.71,4.71,0,0,0,1.26.65,4.52,4.52,0,0,0,1.44.22,4.4,4.4,0,0,0,1.75-.34,4.71,4.71,0,0,0,1.43-.91,4.36,4.36,0,0,0,1-1.36,4,4,0,0,0,.35-1.64v-7.26h-2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M86.91,346.43V347H84.54v-3.08h2.28v.54H85.15v.78h1.39v.53H85.15v.69Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M90.81,343.63v3.3H90.2v-.14a1.42,1.42,0,0,1-.69.18,1.23,1.23,0,0,1,0-2.46,1.45,1.45,0,0,1,.69.18v-1.06Zm-.61,2.59v-1a.9.9,0,0,0-.58-.2.68.68,0,0,0-.71.68.66.66,0,0,0,.71.68A.9.9,0,0,0,90.2,346.22Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M94.7,344.56v2.38h-.61v-.16a1.16,1.16,0,0,1-.65.19c-.69,0-1-.32-1-1.09v-1.32H93v1.32c0,.37.18.55.51.55a.81.81,0,0,0,.54-.19v-1.68Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M98.44,346.5a1.13,1.13,0,0,1-.91.47,1.23,1.23,0,1,1,0-2.45,1.12,1.12,0,0,1,.92.47l-.39.36a.66.66,0,0,0-.53-.28.68.68,0,1,0,0,1.36.65.65,0,0,0,.53-.3Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M102.34,344.56v2.38h-.61v-.18a1.22,1.22,0,0,1-.69.21,1.23,1.23,0,0,1,0-2.46,1.36,1.36,0,0,1,.69.2v-.15Zm-.61.71a.85.85,0,0,0-.58-.2.67.67,0,0,0-.71.67.69.69,0,0,0,.71.69.86.86,0,0,0,.58-.21Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M104.73,345.07v.84c0,.42.07.54.37.54l.28,0v.46a1.84,1.84,0,0,1-.55.08.69.69,0,0,1-.72-.75v-1.15h-.33v-.51h.33v-.92h.62v.92h.66v.51Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M106.84,344a.35.35,0,0,1,.35-.35.36.36,0,0,1,0,.71A.36.36,0,0,1,106.84,344Zm0,.62h.61V347h-.61Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M111.64,345.75a1.3,1.3,0,1,1-1.3-1.23A1.26,1.26,0,0,1,111.64,345.75Zm-.6,0a.7.7,0,1,0-.7.68A.69.69,0,0,0,111,345.75Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M115.43,345.65V347h-.61v-1.32c0-.37-.18-.55-.52-.55a.75.75,0,0,0-.52.19V347h-.61V344.6h.61v.15a1,1,0,0,1,.63-.2C115.11,344.55,115.43,344.88,115.43,345.65Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M120.2,344.43v1.1h1.47v.54H120.2v.9h-.61v-3.08h2.33v.54Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M125.84,345.75a1.3,1.3,0,1,1-1.3-1.23A1.26,1.26,0,0,1,125.84,345.75Zm-.6,0a.7.7,0,0,0-1.4,0,.7.7,0,0,0,1.4,0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M129.62,344.56v2.38H129v-.16a1.16,1.16,0,0,1-.65.19c-.69,0-1-.32-1-1.09v-1.32H128v1.32c0,.37.18.55.51.55a.81.81,0,0,0,.54-.19v-1.68Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M133.52,345.65V347h-.61v-1.32c0-.37-.18-.55-.51-.55a.78.78,0,0,0-.53.19V347h-.61V344.6h.61v.15a1.08,1.08,0,0,1,.64-.2C133.2,344.55,133.52,344.88,133.52,345.65Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M137.54,343.63v3.3h-.61v-.14a1.49,1.49,0,0,1-.7.18,1.23,1.23,0,0,1,0-2.46,1.45,1.45,0,0,1,.7.18v-1.06Zm-.61,2.59v-1a.93.93,0,0,0-.59-.2.67.67,0,0,0-.7.68.66.66,0,0,0,.7.68A1,1,0,0,0,136.93,346.22Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M141.56,344.56v2.38H141v-.18a1.22,1.22,0,0,1-.69.21,1.23,1.23,0,0,1,0-2.46,1.36,1.36,0,0,1,.69.2v-.15Zm-.61.71a.85.85,0,0,0-.58-.2.68.68,0,0,0-.71.67.69.69,0,0,0,.71.69.86.86,0,0,0,.58-.21Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M144,345.07v.84c0,.42.07.54.37.54l.28,0v.46a1.84,1.84,0,0,1-.55.08.69.69,0,0,1-.72-.75v-1.15H143v-.51h.33v-.92H144v.92h.66v.51Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M146.06,344a.35.35,0,0,1,.35-.35.36.36,0,0,1,0,.71A.36.36,0,0,1,146.06,344Zm.05.62h.61V347h-.61Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M150.86,345.75a1.3,1.3,0,1,1-1.3-1.23A1.26,1.26,0,0,1,150.86,345.75Zm-.6,0a.7.7,0,0,0-1.4,0,.7.7,0,0,0,1.4,0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M154.65,345.65V347H154v-1.32c0-.37-.18-.55-.52-.55a.75.75,0,0,0-.52.19V347h-.61V344.6H153v.15a1,1,0,0,1,.63-.2C154.33,344.55,154.65,344.88,154.65,345.65Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M98.91,352.4v.54H96.53v-3.09h2.28v.54H97.14v.79h1.4v.53h-1.4v.69Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M101.73,349.63v3.31h-.61v-.14a1.49,1.49,0,0,1-.7.18,1.23,1.23,0,0,1,0-2.46,1.45,1.45,0,0,1,.7.18v-1.07Zm-.61,2.59v-1a.9.9,0,0,0-.59-.21.68.68,0,0,0-.71.69.67.67,0,0,0,.71.68A.9.9,0,0,0,101.12,352.22Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M104.53,350.56v2.38h-.61v-.16a1.09,1.09,0,0,1-.65.2c-.7,0-1-.33-1-1.1v-1.32h.61v1.32c0,.37.18.55.52.55a.81.81,0,0,0,.54-.19v-1.68Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M107.19,352.5a1.15,1.15,0,0,1-.92.48,1.23,1.23,0,1,1,0-2.46,1.14,1.14,0,0,1,.93.47l-.39.36a.67.67,0,0,0-.54-.29.69.69,0,1,0,0,1.37.67.67,0,0,0,.54-.29Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M110,350.56v2.38h-.61v-.17a1.28,1.28,0,0,1-.7.21,1.24,1.24,0,0,1,0-2.47,1.42,1.42,0,0,1,.7.2v-.15Zm-.61.71a.9.9,0,0,0-.59-.21.68.68,0,0,0-.71.68.69.69,0,0,0,.71.69,1,1,0,0,0,.59-.2Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M111.3,351.06v.85c0,.42.07.55.38.55a2.19,2.19,0,0,0,.28,0v.46a1.45,1.45,0,0,1-.55.09.69.69,0,0,1-.72-.75v-1.17h-.34v-.5h.34v-.93h.61v.93H112v.5Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M112.33,350a.35.35,0,1,1,.35.35A.36.36,0,0,1,112.33,350Zm0,.61H113v2.38h-.61Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M116,351.75a1.3,1.3,0,1,1-1.3-1.23A1.26,1.26,0,0,1,116,351.75Zm-.6,0a.7.7,0,1,0-.7.68A.69.69,0,0,0,115.44,351.75Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M118.75,351.61v1.33h-.61v-1.33c0-.37-.18-.55-.52-.55a.78.78,0,0,0-.53.19v1.69h-.61v-2.38h.61v.15a1.15,1.15,0,0,1,.64-.19C118.43,350.52,118.75,350.84,118.75,351.61Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M123.35,351.57a6,6,0,0,1-.47.71l.37.36-.37.34-.34-.34a1.36,1.36,0,0,1-.82.34c-.71,0-1.17-.34-1.17-.9a.93.93,0,0,1,.65-.83.82.82,0,0,1-.27-.6.88.88,0,0,1,1.75-.06.94.94,0,0,1-.67.84l.54.51a5,5,0,0,0,.36-.51Zm-1.13.73-.69-.68c-.25.1-.37.26-.37.44s.21.43.59.43A.73.73,0,0,0,122.22,352.3Zm-.78-1.63a.62.62,0,0,0,.27.44c.2-.06.46-.2.46-.45a.36.36,0,0,0-.37-.4A.38.38,0,0,0,121.44,350.67Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M127.44,349.85h.68l-1.44,3.09h-.29L125,349.85h.68l.9,2Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M128.39,350a.36.36,0,0,1,.36-.36.36.36,0,0,1,0,.71A.36.36,0,0,1,128.39,350Zm.05.61h.61v2.38h-.61Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M129.72,352.3a2,2,0,0,0,.82.19c.28,0,.39-.1.39-.23s-.14-.2-.51-.27-.88-.28-.88-.75.35-.72.9-.72a2.25,2.25,0,0,1,.93.19l-.2.45a2.14,2.14,0,0,0-.74-.16c-.23,0-.35.09-.35.21s.15.2.53.28c.55.11.87.3.87.74s-.35.75-1,.75a2.11,2.11,0,0,1-1-.23Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M134.3,350.56v2.38h-.61v-.17a1.22,1.22,0,0,1-.69.21,1.24,1.24,0,0,1,0-2.47,1.36,1.36,0,0,1,.69.2v-.15Zm-.61.71a.9.9,0,0,0-.59-.21.69.69,0,1,0,0,1.37.93.93,0,0,0,.59-.2Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M138.65,352c0,.6-.48,1-1.2,1a2.41,2.41,0,0,1-1.28-.29l.22-.49a2.19,2.19,0,0,0,1.08.24c.34,0,.54-.13.54-.35s-.2-.31-.66-.41c-.63-.15-1.15-.33-1.15-.94s.44-.93,1.15-.93a3,3,0,0,1,1.18.25l-.25.5a2.88,2.88,0,0,0-.95-.2c-.31,0-.49.14-.49.33s.22.31.69.42C138.19,351.26,138.65,351.47,138.65,352Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M139.6,351.92a.65.65,0,0,0,.68.54.76.76,0,0,0,.61-.3l.39.33a1.33,1.33,0,0,1-1.07.49,1.23,1.23,0,0,1,0-2.46,1.14,1.14,0,0,1,1.16,1.27s0,.09,0,.13Zm0-.39h1.18a.52.52,0,0,0-.57-.53A.63.63,0,0,0,139.6,351.53Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M142.42,350.89a.89.89,0,0,1,.75-.37.41.41,0,0,1,.15,0v.66a2.1,2.1,0,0,0-.3,0,.56.56,0,0,0-.6.62v1.15h-.62v-2.38h.62Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M146.09,350.56,145,352.94h-.29l-1.15-2.38h.64l.65,1.35.65-1.35Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M146.4,350a.35.35,0,1,1,.35.35A.36.36,0,0,1,146.4,350Zm0,.61h.61v2.38h-.61Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M149.74,352.5a1.18,1.18,0,0,1-.93.48,1.23,1.23,0,1,1,0-2.46,1.13,1.13,0,0,1,.93.47l-.39.36a.67.67,0,0,0-.54-.29.69.69,0,1,0,0,1.37.67.67,0,0,0,.54-.29Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M150.59,351.92a.65.65,0,0,0,.68.54.76.76,0,0,0,.61-.3l.39.33a1.33,1.33,0,0,1-1.07.49,1.23,1.23,0,0,1,0-2.46,1.14,1.14,0,0,1,1.16,1.27s0,.09,0,.13Zm0-.39h1.18a.52.52,0,0,0-.57-.53A.63.63,0,0,0,150.59,351.53Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M152.89,352.3a2,2,0,0,0,.82.19c.28,0,.39-.1.39-.23s-.14-.2-.51-.27-.89-.28-.89-.75.36-.72.91-.72a2.29,2.29,0,0,1,.93.19l-.2.45a2.14,2.14,0,0,0-.74-.16c-.23,0-.35.09-.35.21s.14.2.53.28c.55.11.87.3.87.74s-.35.75-1,.75a2.11,2.11,0,0,1-1-.23Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 49.23,
    x2: 567.05,
    y2: 49.23
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 392.61,
    x2: 567.05,
    y2: 392.61
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 0.12,
    x2: 0.13,
    y2: 392.61
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 343.51,
    y1: 0.12,
    x2: 343.51,
    y2: 392.61
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 34.46,
    y1: 0.12,
    x2: 34.46,
    y2: 392.61
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 68.8,
    y1: 0.12,
    x2: 68.8,
    y2: 392.61
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 103.14,
    y1: 0.12,
    x2: 103.14,
    y2: 392.61
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 137.48,
    y1: 0.12,
    x2: 137.48,
    y2: 392.61
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 171.82,
    y1: 0.12,
    x2: 171.82,
    y2: 392.61
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 206.16,
    y1: 0.12,
    x2: 206.16,
    y2: 392.61
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 240.49,
    y1: 0.12,
    x2: 240.49,
    y2: 392.61
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 274.83,
    y1: 0.12,
    x2: 274.83,
    y2: 392.61
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 309.17,
    y1: 0.12,
    x2: 309.17,
    y2: 392.61
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 17.29,
    y1: 0.12,
    x2: 17.29,
    y2: 392.61
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 51.63,
    y1: 0.12,
    x2: 51.63,
    y2: 392.61
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 85.97,
    y1: 0.12,
    x2: 85.97,
    y2: 392.61
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 120.31,
    y1: 0.12,
    x2: 120.31,
    y2: 392.61
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 154.65,
    y1: 0.12,
    x2: 154.65,
    y2: 392.61
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 188.99,
    y1: 0.12,
    x2: 188.99,
    y2: 392.61
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 223.33,
    y1: 0.12,
    x2: 223.33,
    y2: 392.61
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 257.66,
    y1: 0.12,
    x2: 257.66,
    y2: 392.61
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 292,
    y1: 0.12,
    x2: 292,
    y2: 392.61
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 326.34,
    y1: 0.12,
    x2: 326.34,
    y2: 392.61
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 358.28,
    x2: 567.05,
    y2: 358.28
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 323.94,
    x2: 567.05,
    y2: 323.94
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 289.6,
    x2: 567.05,
    y2: 289.6
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 255.26,
    x2: 567.05,
    y2: 255.26
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 220.92,
    x2: 567.05,
    y2: 220.92
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 186.58,
    x2: 567.05,
    y2: 186.58
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 152.24,
    x2: 567.05,
    y2: 152.24
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 117.91,
    x2: 567.05,
    y2: 117.91
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 83.57,
    x2: 567.05,
    y2: 83.57
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 375.45,
    x2: 567.05,
    y2: 375.45
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 341.11,
    x2: 567.05,
    y2: 341.11
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 306.77,
    x2: 567.05,
    y2: 306.77
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 272.43,
    x2: 567.05,
    y2: 272.43
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 238.09,
    x2: 567.05,
    y2: 238.09
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 203.75,
    x2: 567.05,
    y2: 203.75
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 169.41,
    x2: 567.05,
    y2: 169.41
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 135.08,
    x2: 567.05,
    y2: 135.08
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 100.74,
    x2: 567.05,
    y2: 100.74
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 66.4,
    x2: 567.05,
    y2: 66.4
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 377.85,
    y1: 0.12,
    x2: 377.85,
    y2: 392.61
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 412.19,
    y1: 0.12,
    x2: 412.19,
    y2: 392.61
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 446.53,
    y1: 0.12,
    x2: 446.53,
    y2: 392.61
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 480.86,
    y1: 0.12,
    x2: 480.86,
    y2: 392.61
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 515.2,
    y1: 0.12,
    x2: 515.2,
    y2: 392.61
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 549.54,
    y1: 0.12,
    x2: 549.54,
    y2: 392.61
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 360.68,
    y1: 0.12,
    x2: 360.68,
    y2: 392.61
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 395.02,
    y1: 0.12,
    x2: 395.02,
    y2: 392.61
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 429.36,
    y1: 0.12,
    x2: 429.36,
    y2: 392.61
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 463.7,
    y1: 0.12,
    x2: 463.7,
    y2: 392.61
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 498.03,
    y1: 0.12,
    x2: 498.03,
    y2: 392.61
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 532.37,
    y1: 0.12,
    x2: 532.37,
    y2: 392.61
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 566.71,
    y1: 0.12,
    x2: 566.71,
    y2: 392.61
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 32.06,
    x2: 567.05,
    y2: 32.06
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 0.13,
    y1: 14.89,
    x2: 567.05,
    y2: 14.89
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 0.13,
    y: 0.13,
    width: 566.93,
    height: 392.49
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "translate(0.12 409.37)"
  }, "Size: 13inches x 9inches")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial4);
export default __webpack_public_path__ + "static/media/guideMaterial4.bc3674cb811e69492c8012f09c67a209.svg";
export { ForwardRef as ReactComponent };